import { h, Component } from 'preact';
import Store from 'store/store';


export default class Button extends Component {

	constructor(props) {
		super();
		if (props) {
			this.action = props.action;
			this.actionParams = props.actionParams;
		}
		this.trigger = this.trigger.bind(this);
	}

	trigger() {
		if (!this.action) return;
		if (typeof this.action === 'function') {
			return this.action.apply(null, this.actionParams);
		}
		Store.emit.apply(Store, [this.action].concat(this.actionParams));
	}

	render(props) {
		const {
			children,
			buttonClass
		} = props;

		return (
			<button class={buttonClass} onClick={this.trigger}>
				{children}
			</button>
		);
	}

}
